<template>
  <div class="main-container">
    <div class="main-header">
      <div class="logo-box">
        <img src="/images/logo.png" alt="">
      </div>
      <div class="name-box">贝利婴幼儿发展量表第四版中文·筛查版2.0统计分析系统</div>
      <topMenu :num="2"></topMenu>
    </div>
    <div class="main-body column">
      <div class="header">
        <div class="title-box"><img src="/images/input-header-icon.png" alt=""><span class="name">基本信息</span></div>
      </div>
      <div class="body">
        <div class="de" style="margin:0 0 40px 0;font-size: 14px">ps: <span style="color: #832C75">*</span>为必填项
        </div>
        <a-form-model ref="form" :model="formModel" :rules="formRules" autoComplete="off" :label-col="labelCol"
                      :wrapper-col="wrapperCol" labelAlign="left">
          <a-row>
            <a-col :span="12">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="诊疗卡号">
                    <div class="flex">
                      <a-input allowClear class="cu-input1" v-model="formModel.archives_num" />
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="记分编号" prop="scoring_num">
                    <div class="flex">
                      <a-input class="cu-input1" v-model="formModel.scoring_num" disabled/>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="姓名" prop="name">
                    <div class="flex">
                      <a-input allowClear class="cu-input1" v-model="formModel.name"/>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="性别" prop="gender">
                    <div class="flex" style="margin-top: 10px">
                      <a-radio-group v-model="formModel.gender">
                        <a-radio :value="1">男</a-radio>
                        <a-radio :value="2">女</a-radio>
                      </a-radio-group>
                    </div>
                  </a-form-model-item>
                  <a-form-model-item label="测试日期" prop="test_date">
                    <a-date-picker :disabled-date="disabledDateTest" allowClear format="YYYY-MM-DD" style="width: 100%" class="cu-input1"
                                   v-model="formModel.test_date" @change="computingRealAge"/>
                  </a-form-model-item>
                  <a-form-model-item label="出生日期" prop="born_date">
                    <a-date-picker :disabled-date="disabledDateBorn" @change="computingRealAge" allowClear
                                   format="YYYY-MM-DD" style="width: 100%" class="cu-input1"
                                   v-model="formModel.born_date"/>
                  </a-form-model-item>
                  <a-form-model-item label="测试年龄" prop="children.real_age">
                    <a-input class="cu-input1" disabled placeholder="选择测试日期和出生日期后自动计算"
                             v-model="formModel.real_age"/>
                  </a-form-model-item>
                  <a-form-model-item label="是否早产儿" prop="is_premature_infant">
                    <div class="flex" style="margin-top: 10px">
                      <a-radio-group v-model="formModel.is_premature_infant" :disabled="disablePrematureOption" @change="handlePrematureChange">
                        <a-radio :value="0">否</a-radio>
                        <a-radio :value="1">是</a-radio>
                      </a-radio-group>
                    </div>
                  </a-form-model-item>
                  <template v-if="formModel.is_premature_infant === 1">
                    <a-form-model-item label="预产日期" prop="expected_date">
                      <a-date-picker :disabled-date="disabledDateExpected" allowClear format="YYYY-MM-DD" style="width: 100%" class="cu-input1"
                                     v-model="formModel.expected_date" @change="computingRealAge"/>
                    </a-form-model-item>
                    <a-form-model-item label="调整后测试年龄" prop="adjustment_age">
                      <a-input class="cu-input1" disabled placeholder="选择测试日期与预产日期后将自动计算"
                               v-model="formModel.adjustment_age"/>
                    </a-form-model-item>
                  </template>
                  <a-form-model-item label="主试姓名" prop="examiner_name">
                    <div class="flex">
                      <a-input class="cu-input1" v-model="formModel.examiner_name" disabled/>
                    </div>
                  </a-form-model-item>
                  <!--                  <a-form-model-item label="所在年级" prop="grade">
                                      <a-select placeholder="请选择" v-model="formModel.grade">
                                        <a-select-option value="幼儿园大班">幼儿园大班</a-select-option>
                                        <a-select-option value="学前班">学前班</a-select-option>
                                        <a-select-option value="小学一年级">小学一年级</a-select-option>
                                        <a-select-option value="小学二年级">小学二年级</a-select-option>
                                        <a-select-option value="小学三年级">小学三年级</a-select-option>
                                        <a-select-option value="小学四年级">小学四年级</a-select-option>
                                        <a-select-option value="小学五年级">小学五年级</a-select-option>
                                        <a-select-option value="小学六年级">小学六年级</a-select-option>
                                        <a-select-option value="初中一年级">初中一年级</a-select-option>
                                        <a-select-option value="初中二年级">初中二年级</a-select-option>
                                        <a-select-option value="初中三年级">初中三年级</a-select-option>
                                        <a-select-option value="高中一年级">高中一年级</a-select-option>
                                        <a-select-option value="高中二年级">高中二年级</a-select-option>
                                        <a-select-option value="高中三年级">高中三年级</a-select-option>
                                      </a-select>
                                    </a-form-model-item>-->
                </a-col>
              </a-row>
            </a-col>
            <a-col :span="11" class="right-box">
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="照护者姓名">
                    <div class="flex">
                      <a-input allowClear class="cu-input1" v-model="formModel.caregivers_name"/>
                    </div>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="与儿童关系">
                    <a-select placeholder="请选择" v-model="formModel.relationship_of_child">
                      <a-select-option value="FATHER">父亲</a-select-option>
                      <a-select-option value="MONTHER">母亲</a-select-option>
                      <a-select-option value="GRAND_FATHER">（外）祖父母</a-select-option>
                      <a-select-option value="OTHER">其他</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row v-if="formModel.relationship_of_child === 'OTHER'">
                <a-col :span="24">
                  <a-form-model-item label="与儿童关系补充">
                    <div class="flex">
                      <a-input allowClear class="cu-input1" v-model="formModel.relationship_remark"/>
                    </div>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="评估原因">
                    <div class="flex">
                      <a-input allowClear class="cu-input1" v-model="formModel.referral_remark"/>
                    </div>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <div class="line1" style="margin-bottom: 40px;margin-top: 10px"></div>
          <div style="display: flex;align-items: center;justify-content: center;cursor: pointer">
            <div class="btn" @click="actionData">提交</div>
          </div>
        </a-form-model>
      </div>
    </div>
    <footer-bottom></footer-bottom>
  </div>
</template>

<script>
import * as Api from './api';
import * as commonApi from '@/commonApi';
import {message} from "ant-design-vue";
import {FindScoringNum, GetRealAge} from "./api";
import moment from "moment";

export default {
  data() {
    return {
      labelCol: {span: 6, style: {color: '#7E8589', fontWeight: '500'}},
      wrapperCol: {span: 16},
      formModel: {
        archives_num: '',
        scoring_num: '',
        name: '',
        examiner_name: '',
        gender: 1,
        is_minorities: 1,
        hand_habit: 2,
        exam_address: '',
        born_date: '',
        real_age: '',
        remark: '',
        certificate_no: '',
        grade: undefined,
        parent_culture: undefined,
        is_premature_infant: 0,
        expected_date: '', // Ensure expected_date is part of formModel
        adjustment_age : '',
      },
      disablePrematureOption: false,
      formRules: {
        scoring_num: [
          {required: true, message: '请生成记分编号', trigger: 'change'},
        ],
        name: [
          {required: true, message: '请输入姓名', trigger: 'change'},
        ],
        examiner_name: [
          {required: true, message: '请获取主试姓名', trigger: 'change'},
        ],
        gender: [
          {required: true, message: '请选择性别', trigger: 'change'},
        ],
        test_date: [
          {required: true, message: '请选择测试日期', trigger: 'change'},
        ],
        is_premature_infant: [
          {required: true, message: '请选择是否早产儿', trigger: 'change'},
        ],
        expected_date: [
          {required: true, message: '请选择预产日期', trigger: 'change'},
        ],
        adjustment_age : [
          {required: true, message: '请计算调整后测试年龄', trigger: 'change'},
        ],
        born_date: [
          {required: true, message: '请选择出生日期', trigger: 'change'},
        ],
        exam_address: [
          {required: true, message: '请输入测试地点', trigger: 'change'},
        ],
        real_age: [
          {required: true, message: '请选择出生日期后生成实际年龄', trigger: 'change'},
        ],
      },
    };
  },
  mounted() {
    this.getInfo();
    this.findScoringNum();
  },
  methods: {
    disabledDateBorn(current) {
      if (moment(current).format('L') > moment(new Date()).format('L')) {
        return true;
      }
      if (this.formModel.is_premature_infant === 1 && this.formModel.expected_date) {
        return moment(current).format('L') >= moment(this.formModel.expected_date).format('L');
      }
      return false;
    },
    disabledDateExpected(current) {
      if (moment(current).format('L') > moment(new Date()).format('L')) {
        return true;
      }
      if (this.formModel.is_premature_infant === 1 && this.formModel.born_date) {
        return moment(current).format('L') <= moment(this.formModel.born_date).format('L');
      }
      return false;
    },
    disabledDate(current) {
      return moment(current).format('L') > moment(new Date()).format('L')
    },
    disabledDateTest(current) {
      if (moment(current).format('L') > moment(new Date()).format('L')) {
        return true;
      }
      if (this.formModel.born_date) {
        return moment(current).format('L') < moment(this.formModel.born_date).format('L');
      }
      return false;
    },
    validateAge(result) {
      if (!result || result.trim() === '') {
        message.error({content: '测试年龄不能为空'});
        return false;
      }
      const yearsMatch = result.match(/(\d+)岁/);
      const monthsMatch = result.match(/(\d+)个月/);
      const daysMatch = result.match(/(\d+)天/);
      const years = yearsMatch ? parseInt(yearsMatch[1], 10) : 0;
      const months = monthsMatch ? parseInt(monthsMatch[1], 10) : 0;
      const days = daysMatch ? parseInt(daysMatch[1], 10) : 0;
      const totalYears = years + Math.floor(months / 12);
      const remainingMonths = months % 12;
      
      if (totalYears === 0 && remainingMonths === 0 && days < 16) {
        message.error({content: '测试年龄必须不能小于0个月16天'});
        return false;
      }
      if (
          totalYears > 3 ||
          (totalYears === 3 && remainingMonths > 6) ||
          (totalYears === 3 && remainingMonths === 6 && days > 30)
      ) {
        message.error({content: '测试年龄必须不能大于3岁6个月30天'});
        return false;
      }
      return true;
    },
    async actionData() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          if (this.formModel.is_premature_infant === 1) {
            if (this.formModel.born_date && this.formModel.expected_date) {
              if (moment(this.formModel.born_date).format('L') >= moment(this.formModel.expected_date).format('L')) {
                message.error({content: '出生日期必须早于预产日期'});
                return;
              }
            }
          }
          if (this.formModel.born_date && this.formModel.test_date) {
            if (moment(this.formModel.test_date).format('L') < moment(this.formModel.born_date).format('L')) {
              message.error({content: '测试日期不能早于出生日期'});
              return;
            }
          }
          if(this.validateAge(this.formModel.real_age)){
            window.localStorage.setItem('base_info', JSON.stringify(this.formModel));
            this.$router.push({path: '/select-age'})
          }
        }
      });
    },
    goSelectAge() {
      this.$router.push({path: '/select-age'})
    },
    async getInfo() {
      const res = await Api.GetInfo({});
      if (res && res.code == 0) {
        this.formModel.examiner_name = res.chiefExaminer.name;
        this.formModel.certificate_no = res.chiefExaminer.certificate_no;
      }
    },
    async findScoringNum() {
      const res = await Api.FindScoringNum({});
      if (res && res.code == 0) {
        this.formModel.scoring_num = this.formModel.certificate_no + res.scoringNum;
      }
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const result = `${year}-${month}-${day}`;
      return result;
    },
    // 年龄限时转换
    converAge(input){
      const parts = input.split(':');
      const firstPart = parseInt(parts[0], 10);
      const secondPart = parseInt(parts[1], 10);
      let years = 0;
      let months = 0;
      let days = 0;
      if (firstPart >= 12) {
        // years = Math.floor(firstPart / 12);
        months = firstPart ;
      } else {
        months = firstPart;
      }
      days = secondPart;
      let result = '';
      if (years > 0) {
        result += `${years}岁`;
      }
      if (months > 0) {
        result += `${months}个月`;
      }
      if (days > 0) {
        result += `${days}天`;
      }
      return result;
    },
    parseAgeStringToTotalMonths(ageString) {
      if (!ageString) return 0;
      let totalMonths = 0;
      const yearsMatch = ageString.match(/(\d+)岁/);
      const monthsMatch = ageString.match(/(\d+)个月/);

      if (yearsMatch && yearsMatch[1]) {
        totalMonths += parseInt(yearsMatch[1], 10) * 12;
      }
      if (monthsMatch && monthsMatch[1]) {
        totalMonths += parseInt(monthsMatch[1], 10);
      }
      // If only months are present without '岁' (e.g. "25个月10天" from converAge)
      // and no years, this logic should correctly sum them up.
      // If the format is strictly "X岁Y个月Z天" or "Y个月Z天" or "X岁Z天", this is fine.
      // If the format could be "25个月" directly from converAge, it's also fine.
      return totalMonths;
    },
    updatePrematureFieldsBasedOnAge() {
      if (!this.formModel.real_age) {
        this.disablePrematureOption = false;
        return;
      }
      const totalMonths = this.parseAgeStringToTotalMonths(this.formModel.real_age);
      if (totalMonths >= 24) {
        this.formModel.is_premature_infant = 0;
        this.formModel.expected_date = '';
        this.formModel.adjustment_age = '';
        this.disablePrematureOption = true;
      } else {
        this.disablePrematureOption = false;
      }
    },
    handlePrematureChange(e){
      // if user manually changes to NO, clear related fields
      if(e.target.value === 0){
        this.formModel.expected_date = '';
        this.formModel.adjustment_age = '';
      }
    },
    async computingRealAge() {
      if(this.formModel.test_date && this.formModel.born_date){
        if (this.formModel.is_premature_infant === 1 && this.formModel.expected_date) {
          if (moment(this.formModel.born_date).format('L') >= moment(this.formModel.expected_date).format('L')) {
            message.warning({content: '出生日期已晚于预产日期，请重新选择预产日期'});
            this.formModel.expected_date = '';
            this.formModel.adjustment_age = '';
          }
        }
        if (moment(this.formModel.test_date).format('L') < moment(this.formModel.born_date).format('L')) {
          message.warning({content: '测试日期已早于出生日期，请重新选择测试日期'});
          this.formModel.test_date = '';
          this.formModel.real_age = '';
          return;
        }
        const res = await GetRealAge({
          born_time:this.formatDate(this.formModel.born_date.toDate()),
          test_date: this.formatDate(this.formModel.test_date.toDate())
        });
        if (res && res.code == 0) {
          this.formModel.real_age = this.converAge(res.realAgeValue);
          this.updatePrematureFieldsBasedOnAge(); // Call after real_age is set
        }
      }
      if(!this.formModel.test_date){
        this.formModel.real_age = "";
        this.formModel.adjustment_age = "";
        this.updatePrematureFieldsBasedOnAge(); // Call when test_date is cleared
      }
      if(!this.formModel.born_date){
        this.formModel.real_age = "";
        this.updatePrematureFieldsBasedOnAge(); // Call when born_date is cleared
      }
      if(this.formModel.test_date && this.formModel.expected_date){
        const res = await GetRealAge({
          born_time:this.formatDate(this.formModel.expected_date.toDate()),
          test_date: this.formatDate(this.formModel.test_date.toDate())
        });
        if (res && res.code == 0) {
          // console.log(111); // Removed console.log
          this.formModel.adjustment_age = this.converAge(res.realAgeValue);
          // console.log(this.formModel.adjustment_age); // Removed console.log
        }
      }
      if(!this.formModel.expected_date){
        this.formModel.adjustment_age = "";
      }
    },

    changeBornTime(e, s) {
      this.formModel.born_date = s;
    }

  }
};
</script>
<style>

</style>
<style scoped>

.main-body {
  background-image: url("/images/maintain-bg.png");
  align-items: flex-start;
  justify-content: flex-start;
}

.line1 {
  border: 1px solid #f8f8f8;
  margin-bottom: 20px;
}

.ant-form-item-control .ant-form-item-children {
  display: flex;
}

.num-de {
  font-size: 12px;
  font-weight: 400;
  color: #999A9A;
  width: 100px;
  text-align: center;
}

.flex {
  display: flex;
}

.right-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  border-left: 1px solid #eee;
  padding-left: 70px;
  justify-content: flex-start;
}

.right-title {
  font-size: 14px;
  font-weight: 600;
  color: #832C75;
  margin-bottom: 20px;
}

.cu-select {
  line-height: 42px;
  height: 42px;
}

.btn {
  background: #832C75;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 45px;
  text-align: center;
  cursor: pointer;
  padding: 0 40px;
}

.btn.sh {
  border: 1px solid #832B75;
  border-radius: 5px;
  font-weight: 400;
  color: #832B75;
  line-height: 45px;
  background: #FFFFFF;
  display: inline;
  display: flex;
  align-items: center;
}

.ant-form-item {
  margin-bottom: 12px !important;
}
</style>
